export enum TOPBAR_POSITION {
  ONTOP = 'onTop',
  SCROLLED = 'scrolled',
}

// Height of one row of the desktop app bar. The bar and its tabs are sized by
// it, and everything that offsets content below the bar reads the same value.
export const APP_BAR_DESKTOP_HEIGHT = 54;
